<div class="couponTip" [class.show]="show">
  <div class="couponTip-wrapper">
    <a class="close-button" (click)="closePopupEvent(false)"> &#10005; </a>
    <p class="heading">
      <strong>Jetzt abschließen und 250 € Reise Guthaben sichern!</strong>
    </p>

    <p>
      Für Pauschalreisen- und Ferienwohnungsbuchungen können Sie bis zu
      200&nbsp;€ Guthaben einlösen. Dabei gilt folgende Staffelung:
    </p>
    <ul>
      <li>
        <strong>200&nbsp;€</strong> Guthaben einlösbar
        <strong>ab 3.500&nbsp;€</strong>
        Gesamtpreis
      </li>
      <li>
        <strong>120&nbsp;€</strong> Guthaben einlösbar
        <strong>von 1.800&nbsp;€ bis unter 3.500&nbsp;€</strong> Gesamtpreis
      </li>
      <li>
        <strong>60&nbsp;€</strong> Guthaben einlösbar
        <strong>von 800&nbsp;€ bis unter 1.800&nbsp;€</strong> Gesamtpreis
      </li>
      <li>
        <strong>30&nbsp;€</strong> Guthaben einlösbar
        <strong>von 300&nbsp;€ bis unter 800&nbsp;€</strong> Gesamtpreis
      </li>
      <li>
        <strong>10&nbsp;€</strong> Guthaben einlösbar
        <strong>von 100&nbsp;€ bis unter 300&nbsp;€</strong> Gesamtpreis
      </li>
    </ul>

    <p>
      Für Mietwagen können Sie bis zu 50&nbsp;€ Guthaben einlösen. Dabei gilt
      folgende Staffelung:
    </p>
    <ul>
      <li>
        <strong>50&nbsp;€</strong> Guthaben einlösbar
        <strong>ab 1.000&nbsp;€</strong>
        Gesamtpreis
      </li>
      <li>
        <strong>25&nbsp;€</strong> Guthaben einlösbar
        <strong>von 500&nbsp;€ bis unter 1.000&nbsp;€</strong> Gesamtpreis
      </li>
      <li>
        <strong>10&nbsp;€</strong> Guthaben einlösbar
        <strong>von 100&nbsp;€ bis unter 500&nbsp;€</strong> Gesamtpreis
      </li>
    </ul>

    <p>
      Weitere informationen finden Sie in den
      <a
        href="https://www.check24.at/teilnahmebedingungen-werbeaktionen"
        target="_blank"
        rel="noreferrer"
      >
        Teilnahmebedingungen
      </a>
    </p>
  </div>
</div>

<div *ngIf="show" class="overlay" (click)="closePopupEvent(false)"></div>
